import SelectForms from "./select-forms-component";
import * as list from "src/core/statics/form-data/form-data";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { appRoutesObj } from "src/app.paths";
import { useEffect, useRef, useState } from "react";
import PopupComponent from "./popup-register-page-component";
import * as data from "src/core/statics/Termsـconditionsـprivacyـpolicy/static_data";
import { useFormik } from "formik";
import { registerValidationSchema } from "./validation/register-form-validation";
import { HiOutlineCheck } from "react-icons/hi";

function RegisterFormComponent() {
  const [isOpenPopupTermsAndConditions, setIsOpenPopupTermsAndConditions] =
    useState<boolean>(false);
  const [isOpenPopupPrivacyAndPolicy, setIsOpenPopupPrivacyAndPolicy] =
    useState<boolean>(false);
  const [showCountryOptions, setShowCountryOptions] = useState<boolean>(false);
  const [showEduSystemOptions, setShowEduSystemOptions] =
    useState<boolean>(false);
  const [isCountrySelected, setIsCountrySelected] = useState<boolean>(false);
  const [isEduSystemSelected, setIsEduSystemSelected] =
    useState<boolean>(false);
  const [country, setCountry] = useState("");
  const [eduSystem, setEduSystem] = useState("");
  const navigate = useNavigate();
  const popupRef = useRef<HTMLDivElement>(null);
  const { i18n, t } = useTranslation();

  const handleClickOnCountryOption = (item: string) => {
    setCountry(item);
    setIsCountrySelected(true);
    setShowCountryOptions(false);
  };
  const handleClickOnEduSystemOption = (item: string) => {
    setEduSystem(item);
    setIsEduSystemSelected(true);
    setShowEduSystemOptions(false);
  };
  useEffect(() => {
    const handleClickOutSidePopup = ({ target }: MouseEvent) => {
      if (!popupRef?.current?.contains(target as Node)) {
        setIsOpenPopupTermsAndConditions(false);
        setIsOpenPopupPrivacyAndPolicy(false);
      }
    };
    document.body.addEventListener("click", handleClickOutSidePopup, true);

    return () => {
      document.body.removeEventListener("click", handleClickOutSidePopup);
    };
  }, []);

  const moreThanThreeCharsRegEx = /([a-zA-Z]|[0-9]|[-_.]){3,}/;
  const containAtLeastOneRegEx = /^[A-Za-z0-9_-]*[-_.][A-Za-z0-9_-]*$/;
  const mustNotStartWithNumberRegEx = /^[^0-9].*$/;
  const moreThanEightCharsRegEx = /([a-zA-Z]|[0-9]){8,}/;
  const containAtLeastOnePasswordRegEx = /[&?*%!$@]/;
  const containAtLeastOneLowerOneUpperRegEx = /^(?=.*[a-z])(?=.*[A-Z]).*$/;

  type InitialValuesType = {
    fullName: string;
    email: string;
    userName: string;
    password: string;
    confirmPassword: string;
  };

  const initialValues: InitialValuesType = {
    fullName: "",
    email: "",
    userName: "",
    password: "",
    confirmPassword: "",
  };

  const { values, errors, touched, handleChange, handleSubmit, handleBlur } =
    useFormik({
      initialValues: initialValues,
      validateOnChange: true,
      validateOnBlur: true,
      validationSchema: registerValidationSchema,
      onSubmit: async () => {},
    });

  return (
    <form
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      onSubmit={handleSubmit}
      className="inline-flex flex-col gap-4 items-center justify-center mobile:mt-20 tablet:mt-20"
    >
      <p className="font-arMedium text-black344 text-2xl mobile:text-xl">
        {t("registerForm.component.createAccountParentOfStudent")}
      </p>
      <div className="flex flex-col gap-2">
        <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
          {t("registerForm.component.fullName")}
        </label>
        <input
          value={values.fullName}
          onChange={handleChange}
          onBlur={handleBlur}
          id="fullName"
          type="text"
          className={`${
            touched.fullName && errors.fullName
              ? "border-secondary-50 focus:border-secondary-50"
              : "border-zinc400 focus:border-mint-500"
          } w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-screen mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
          placeholder={`${t("placeholder.fullName.fullNameExample")}`}
        ></input>
        {touched.fullName && errors.fullName && (
          <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
            {errors.fullName}
          </p>
        )}
      </div>
      <div className="flex flex-col gap-2">
        <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
          {t("registerForm.component.email")}
        </label>
        <input
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          id="email"
          type="text"
          className={`${
            touched.email && errors.email
              ? "border-secondary-50 focus:border-secondary-50"
              : "border-zinc400 focus:border-mint-500"
          } w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-screen mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
          placeholder="a@example.sa"
        ></input>
        {touched.email && errors.email && (
          <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
            {errors.email}
          </p>
        )}
      </div>
      <div className="flex flex-col gap-2">
        <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
          {t("registerForm.component.userName")}
        </label>
        <input
          value={values.userName}
          onChange={handleChange}
          onBlur={handleBlur}
          id="userName"
          type="text"
          className={`${
            touched.userName && errors.userName
              ? "border-secondary-50 focus:border-secondary-50"
              : "border-zinc400 focus:border-mint-500"
          } w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-screen mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
          placeholder="a-a12"
        ></input>
        {touched.userName && errors.userName && (
          <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
            {errors.userName}
          </p>
        )}
        <p
          className={`${
            moreThanThreeCharsRegEx.test(values.userName)
              ? "text-green500"
              : "text-zinc400"
          } flex flex-row items-center mt-1 gap-1 text-sm font-ar`}
        >
          <HiOutlineCheck className="text-2xl -mt-1.5" />
          {t("form.error.userName.checkOne")}
        </p>
        <p
          className={`${
            containAtLeastOneRegEx.test(values.userName)
              ? "text-green500"
              : "text-zinc400"
          } flex flex-row items-center gap-1 text-sm font-ar`}
        >
          <HiOutlineCheck className="text-2xl -mt-1.5" />
          {t("form.error.userName.checkTwo")}
        </p>
        <p
          className={`${
            mustNotStartWithNumberRegEx.test(values.userName)
              ? "text-green500"
              : "text-zinc400"
          } flex flex-row items-center gap-1 text-sm font-ar`}
        >
          <HiOutlineCheck className="text-2xl -mt-1.5" />
          {t("form.error.userName.checkThree")}
        </p>
      </div>
      <SelectForms
        currrentValue={
          country === ""
            ? i18n.language === "ar"
              ? list.country[0]
              : list.countryEn[0]
            : country
        }
        showOptions={showCountryOptions}
        isSelected={isCountrySelected}
        onClickOnDropDown={() => setShowCountryOptions(!showCountryOptions)}
        onClickOnOption={(item) => handleClickOnCountryOption(item)}
        label={t("forms.component.country")}
        options={i18n.language === "ar" ? list.country : list.countryEn}
      />
      <SelectForms
        label={t("searchBar.component.academicSystem")}
        options={i18n.language === "ar" ? list.edusystem : list.edusystemEn}
        currrentValue={
          eduSystem === ""
            ? i18n.language === "ar"
              ? list.edusystem[0]
              : list.edusystemEn[0]
            : eduSystem
        }
        showOptions={showEduSystemOptions}
        isSelected={isEduSystemSelected}
        onClickOnDropDown={() => setShowEduSystemOptions(!showEduSystemOptions)}
        onClickOnOption={(item) => handleClickOnEduSystemOption(item)}
      />
      <div className="flex flex-col gap-2">
        <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
          {t("registerForm.component.password")}
        </label>
        <input
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          id="password"
          type="password"
          className={`${
            touched.password && errors.password
              ? "border-secondary-50 focus:border-secondary-50"
              : "border-zinc400 focus:border-mint-500"
          } w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-screen mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
          placeholder="************"
        ></input>
        {touched.password && errors.password && (
          <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
            {errors.password}
          </p>
        )}
        <p
          className={`${
            containAtLeastOnePasswordRegEx.test(values.password)
              ? "text-green500"
              : "text-zinc400"
          } flex flex-row items-center mt-1 gap-1 text-sm font-ar`}
        >
          <HiOutlineCheck className="text-2xl -mt-1.5" />
          {t("form.error.password.checkOne")}
        </p>
        <p
          className={`${
            containAtLeastOneLowerOneUpperRegEx.test(values.password)
              ? "text-green500"
              : "text-zinc400"
          } flex flex-row items-center gap-1 text-sm font-ar`}
        >
          <HiOutlineCheck className="text-2xl -mt-1.5" />
          {t("form.error.password.checkTwo")}
        </p>
        <p
          className={`${
            moreThanEightCharsRegEx.test(values.password)
              ? "text-green500"
              : "text-zinc400"
          } flex flex-row items-center gap-1 text-sm font-ar`}
        >
          <HiOutlineCheck className="text-2xl -mt-1.5" />
          {t("form.error.password.checkThree")}
        </p>
      </div>
      <div className="flex flex-col gap-2">
        <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
          {t("registerForm.component.confirmPassword")}
        </label>
        <input
          value={values.confirmPassword}
          onChange={handleChange}
          onBlur={handleBlur}
          id="confirmPassword"
          type="password"
          className={`${
            touched.confirmPassword && errors.confirmPassword
              ? "border-secondary-50 focus:border-secondary-50"
              : "border-zinc400 focus:border-mint-500"
          } w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-screen mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
          placeholder="************"
        ></input>
        {touched.confirmPassword && errors.confirmPassword && (
          <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
            {errors.confirmPassword}
          </p>
        )}
      </div>

      <button
        type="submit"
        className="w-[345px] h-[55px] mobile:max-w-[345px] mobile:w-screen mobile:h-[61px] px-4 py-2 bg-mint-500 rounded-xl justify-center items-center gap-2 inline-flex text-white text-xl font-arMedium leading-[30px] cursor-pointer"
      >
        {t("app.shared.register")}
      </button>
      <div className="w-[533px] h-14 mobile:w-[341px] flex-col justify-start items-center gap-2 inline-flex">
        <div className="text-center mobile:text-center">
          <span className="text-zinc-400 text-lg font-arMedium leading-7 mobile:text-sm">
            {t("registerForm.component.agree")}
          </span>
          <span
            onClick={() => setIsOpenPopupTermsAndConditions(true)}
            className="text-slate-700 text-lg font-arMedium leading-7 cursor-pointer mobile:text-sm"
          >
            {t("registerForm.component.termsAndCondition")}
          </span>
          <span className="text-zinc-400 text-lg font-arMedium leading-7">
            {t("registerForm.component.and")}
          </span>
          <span
            onClick={() => setIsOpenPopupPrivacyAndPolicy(true)}
            className="text-slate-700 text-lg font-arMedium leading-7 cursor-pointer mobile:text-sm"
          >
            {t("registerForm.component.privacyAndpolicy")}
          </span>
        </div>
        <div className="w-[250px] h-[21px] text-center">
          <span className="text-zinc-400 text-base font-arMedium leading-normal mobile:text-sm">
            {t("app.shared.haveaccount")}
          </span>
          <span
            onClick={() => navigate(appRoutesObj.getSignInPagePath())}
            className="text-mint-500 text-base font-arMedium leading-normal cursor-pointer mobile:text-sm"
          >
            {t("app.shared.signin")}
          </span>
        </div>
      </div>
      <div ref={popupRef}>
        <PopupComponent
          isOpen={isOpenPopupTermsAndConditions}
          title={
            i18n.language === "ar"
              ? data.termsAndConditions.title
              : data.termsAndConditions.titleEn
          }
          description={
            i18n.language === "ar"
              ? data.termsAndConditions.description
              : data.termsAndConditions.descriptionEn
          }
        />
        <PopupComponent
          isOpen={isOpenPopupPrivacyAndPolicy}
          title={
            i18n.language === "ar"
              ? data.privacyAndPolicy.title
              : data.privacyAndPolicy.titleEn
          }
          description={
            i18n.language === "ar"
              ? data.privacyAndPolicy.description
              : data.privacyAndPolicy.descriptionEn
          }
        />
      </div>
    </form>
  );
}

export default RegisterFormComponent;
